import Loadable from 'react-loadable';
import TableLoader from './skeleton/tableLoader';
// import ThreeDots from './skeleton/empty';

//过场组件默认采用通用的，若传入了loading，则采用传入的过场组件
export default (loader,loading = TableLoader)=>{
    return Loadable({
        loader,
        loading
    });
}